import React, { Component } from "react";
import { connect } from "react-redux";
import { handlePickupFormChange } from "../../../redux/actions/pickupForm";
import { enableBack } from "../../../redux/actions/stepper";
import Form from "../../../components/form/Form";
import CircularProgress from "@material-ui/core/CircularProgress";
import renderIf from "../../../utils/renderIf";
import { getSellerCompanyCode } from "../../../utils/cbotUtils";

class PickupDetails extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
    //enable back
    this.props.enableBack();
  }

  updateFields = (stepFields, sellerCompanyCode) =>
    stepFields.map((field) =>
      field.getLabel
        ? {
            ...field,
            label: field.getLabel(sellerCompanyCode || ""),
          }
        : field
    );

  render() {
    const {
      stepTitle,
      stepIntroText,
      stepFields,
      fields,
      handlePickupFormChange,
      apiProcessing,
      showErrors,
      maxAllowedPickupDays,
      holidays,
    } = this.props;
    return (
      <div>
        {renderIf(apiProcessing)(<CircularProgress className="load-spinner" />)}
        {renderIf(!apiProcessing)(
          <div>
            {renderIf(stepTitle)(
              <div className="intro-title">{stepTitle}</div>
            )}
            {renderIf(stepIntroText)(
              <div className="intro-text">{stepIntroText}</div>
            )}
            <div className="step-form">
              <Form
                fieldsStructure={this.updateFields(
                  stepFields,
                  getSellerCompanyCode(fields)
                )}
                fields={fields}
                handleFieldChange={handlePickupFormChange}
                showErrors={showErrors}
                yardProps={{
                  maxAllowedPickupDays: maxAllowedPickupDays,
                  holidays: holidays,
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.pickupForm.fields,
  apiProcessing: state.ui.apiProcessing,
  showErrors: state.pickupForm.currentStepError,
  maxAllowedPickupDays: state.lot.maxAllowedPickupDays,
  holidays: state.lot.holidays,
});

const mapDispatchToProps = {
  handlePickupFormChange,
  enableBack,
};

export default connect(mapStateToProps, mapDispatchToProps)(PickupDetails);



// WEBPACK FOOTER //
// ./src/containers/PickupForm/steps/PickupDetails.js